//import Moment from "moment";

const dataFormatada = (state) => {
    if (!state.usuario || !state.usuario.data) return null;
    return Moment(String(state.usuario.data)).format("DD/MM/YYYY");
}

const getCount = (state) => {
	return state.usuarios.length;
}

export default {
    dataFormatada,
	getCount
}